import { supabase } from "./supabaseClient";

export const fetchPlayer = async (playerId) => {
	try {
		const { data, error } = await supabase
			.from("players")
			.select("*")
			.eq("id", playerId)
			.single();

		if (error && error.code !== "PGRST116") {
			console.error("Error fetching user metadata:", error);
		}

		return { data, error };
	} catch (error) {
		console.error("Unexpected error fetching user metadata:", error);
		return { data: null, error };
	}
};

export const fetchPlayerByEmail = async (quizId, email) => {
	try {
		const { data, error } = await supabase
			.from("players")
			.select("*")
			.eq("email", email)
			.eq("quiz_id", quizId);

		if (error && error.code !== "PGRST116") {
			console.error("Error fetching player:", error);
		}

		if (data && data.length > 0) {
			return { data: data[0], error };
		}

		return { data: null, error };
	} catch (error) {
		console.error("Unexpected error fetching user metadata:", error);
		return { data: null, error };
	}
};

export const createPlayer = async (quizId, email) => {
	try {
		const { data, error } = await supabase
			.from("players")
			.insert([{ email: email, quiz_id: quizId }])
			.select()
			.single(); // Ensures we return the inserted row

		if (error) {
			console.error("Error creating user metadata:", error);
		}
		return { data, error };
	} catch (error) {
		console.error("Unexpected error creating user metadata:", error);
		return { data: null, error };
	}
};

export const fetchOrCreatePlayer = async (quizId, email) => {
	try {
		let { data, error } = await fetchPlayerByEmail(quizId, email);

		if (!data) {
			const created = await createPlayer(quizId, email);
			if (!created.error) {
				return created; // Return the newly created metadata
			}
			return { data: null, error: created.error };
		}

		return { data, error };
	} catch (error) {
		console.error("Error fetching or creating user metadata:", error);
		return { data: null, error };
	}
};

export const updatePlayer = async (playerId, player) => {
	try {
		const { id, created_at, ...playerData } = player;

		const { data, error } = await supabase
			.from("players")
			.update({
				pseudo: playerData?.pseudo || null,
				avatar: playerData?.avatar || null,
				team_id: playerData?.team_id || null,
				quiz_id: playerData?.quiz_id || null,
				email: playerData?.email || null,
			})
			.eq("id", playerId)
			.select()
			.single();

		if (error) {
			console.error("Error updating user metadata:", error);
		}
		return { data, error };
	} catch (error) {
		console.error("Error fetching or creating user metadata:", error);
		return { data: null, error };
	}
};

export const fetchPlayerDetails = async (playerIds) => {
	if (playerIds.length === 0) return {};

	const { data, error } = await supabase
		.from("players")
		.select("id, pseudo, avatar")
		.in("id", playerIds);

	if (error) {
		console.error("Error fetching player details:", error);
		return {};
	}

	// Return as a map for easier lookup
	const playerMap = {};
	data.forEach((player) => {
		playerMap[player.id] = {
			pseudo: player.pseudo,
			avatar: player.avatar,
		};
	});

	return playerMap;
};
